export default {"buttonWrapper":"_buttonWrapper_1l1r9_1","buttonArrowImageWrapper":"_buttonArrowImageWrapper_1l1r9_13"};